const config = {
  deploy: {
    bucket: 'widgets.reservamos.mx',
    widgetName: 'search',
  },
  i18nLng: 'es-MX',
};

export default config;
